<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title> Formas de pago </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text" @click="editItem()">
              <v-icon small class="mr-2">
                mdi-pencil
              </v-icon>
              Agregar
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <!-- <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon> -->
        </template>
      </v-data-table>
    </template>

    <FormasReg ref="formasreg" v-on:newregforma="newregforma" />
  </div>
</template>

<script>
  import FormasReg from '@/views/recibos/fpagos/registrar.vue';
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      loading: false,
      dialogDelete: false,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Descripcion', value: 'descripcion' },
        { text: 'Cod clasificador SIN', value: 'codigo_clasificador_SIN' },
        { text: 'Descripcion SIN', value: 'descripcion_SIN' },
        { text: 'Opciones', value: 'actions', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    }),

    components: { FormasReg },

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        let vue = this;
        vue.loading = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/formaspagos`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            //window.console.log(JSON.stringify(response.data));
            let data = response.data.data;
            vue.desserts = data;
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },

      newregforma(item) {
        let e = this.desserts.find((x) => x.id == item.id);
        if (e) {
          e.nombre = item.nombre;
          e.descripcion = item.descripcion;
          e.codigo_clasificador_SIN = item.codigo_clasificador_SIN;
          e.descripcion_SIN = item.descripcion_SIN;
        }
      },

      editItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialog = true;
        this.$refs.formasreg.openmodal(item);
      },

      deleteItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialogDelete = true;
        this.$refs.unidadesdel.openmodal();
      },

      deleteItemConfirm() {
        this.desserts.splice(this.editedIndex, 1);
        this.closeDelete();
      },

      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
    },
  };
</script>
